import { render, staticRenderFns } from "./_transaction-types.vue?vue&type=template&id=ae5369d6"
import script from "./_transaction-types.vue?vue&type=script&lang=js"
export * from "./_transaction-types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports